import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SyncEntity extends DexResourceModel {

    @Field(String)
    public name: string = '';
    @Field(String)
    public description: string | null = '';

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
